import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './action-image-extension-column.pug';

export class ActionImageExtensionColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n,
    readOnly,
    newI18n,
    deps,
  }) {
    super({
      name: 'Action',
      property: 'Recommendation/ActionImageExtension',
      title: i18n.getString('ColumnName_Action') || 'Action',
      bodyClasses: ['inline-action-image-extension-column'],
      colClasses: ['col-applyEdit'],
    });
    this.i18n = i18n;
    this.readOnly = readOnly;
    this.newI18n = newI18n;
    this.deps = deps;
  }

  pickProperty(recommendation) {
    const {
      i18n,
      readOnly,
      deps,
      newI18n,
    } = this;
    const opportunity = recommendation.Opportunities[0];
    const { OpportunityType } = opportunity;
    const {
      StockImages,
      WebsiteImages,
    } = opportunity;
    const { IsRecommendationGetShutterStockImageFromUXEnabled } = deps.permissions;

    const pickProperities = {
      hasImage: (!_.isEmpty(WebsiteImages) && !_.isEmpty(_.first(WebsiteImages).ImageURL))
        || (!IsRecommendationGetShutterStockImageFromUXEnabled && !_.isEmpty(StockImages)
        && !_.isEmpty(_.first(StockImages).ThumbnailURL)),
      i18n,
      readOnly,
      action: newI18n.getString(_TL_('Add image extension')),
      IsRecommendationGetShutterStockImageFromUXEnabled,
    };

    return _.defaults({
      OpportunityType,
    }, pickProperities);
  }

  get template() { return template; }
}
